import React from 'react';
import TableIcons from "../../utils/TableIcons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import MaterialTable from "material-table";
import _ from 'lodash';

const LeadSourceRows = ({arr, type}) => {
    if (!arr.length) {
        return null;
    }
    const categoryLookup = {};
    let configKeyArr = _.mapValues(_.groupBy(arr, 'configKey'));
    let headerKeys = Object.keys(configKeyArr);
    headerKeys.forEach(cat => {
        categoryLookup[cat] = cat;
    });
    const baseColumns = type !== 'referringSiteUrls' ?
        [
            {title: 'Id', field: "id"},
            {title: 'Type', field: "type", hidden: true},
            {title: "Name", field: "name"},
            {title: "Config Key", field: "configKey", lookup: categoryLookup}
        ]
        :
        [
            {title: 'Referring Site Url', field: "referringSiteUrl"},
            {title: 'Type', field: "type", hidden: true},
            {title: "Config Key", field: "configKey", lookup: categoryLookup}
        ];


    let columns = [
        ...baseColumns,
    ];

    let actions = [
        {
            icon: () => <VisibilityIcon/>,
            tooltip: 'View',
            onClick: (event, rowData) => {
                if (rowData.type === 'TrafficSource') {
                    window.open(`/info/traffic-sources/${rowData.id}`);
                }
            }
        },
    ];
    if (type === 'trafficSource') {
        columns = [
            ...columns,
            {title: "Affiliate Name", field: "affiliateName"},
            {title: "Subcode", field: 'subCode'},
            {title: "Promo Id", field: 'promoId'},
        ];
    } else if (type === 'referringSiteUrls') {
        columns = [
            ...columns,
            {title: "Affiliate Key", field: "affiliateKey"},
        ];
        actions = [];
    } else {
        columns = [
            ...columns,
            {title: "Affiliate Key", field: "affiliateKey"},
            {title: "Subcode", field: 'subCode'},
        ];
        actions = [];
    }

    return (
        <MaterialTable
            title=""
            icons={TableIcons}
            columns={columns}
            data={arr.map(item => ({
                id: item.id,
                type: item['__typename'],
                name: item.name || 'N/A',
                configKey: item.configKey || 'N/A',
                affiliateName: item.affiliate ? item.affiliate.name : 'N/A',
                subCode: item.subCode || 'N/A',
                affiliateKey: item.key || 'N/A',
                promoId: item.legacyPromoId || 'N/A',
                referringSiteUrl: item.referringSiteUrl || "N/A"
            }))}
            actions={actions}
            options={{
                pageSize: 100,
                pageSizeOptions: [100, 200, 300],
                headerStyle: {
                    minWidth: 'auto',
                },
                filtering: true,
                toolbar: false,
                search: false,
            }}
        />
    );
};

export default LeadSourceRows;
